export default __webpack_public_path__ + "static/ipad-2d6f36d73f1157427fa35b8229ef3f36.png";